
import firebase from '@/fb'; 

export default class Activity {
    action = "";
    what = {type: "", id: ""};
    date = new Date().toISOString().substr(0, 10);
 
    constructor(Action, What, currentDate) 
    {
      //Used Tenary operator to determine whether anything was entered/the parameter is defined. If not, set as the default  
      Action ? this.action = Action : this.action = "";
      What ? this.what = What : this.what = {type: "", id: ""};
      currentDate ? this.date = currentDate : this.date = new Date().toISOString().substr(0, 10);
    }

    async pushActivityToFirebase(uid){
        var that = this;
        //Check that the current activity and uid is not null
        if (uid !== null){
            if (Object.keys(this.what).length !== 0){
                const userRef = firebase.db.collection('users');
                userRef.where('uid', "==", uid)
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        var activityQueue;
                        if (doc.data().activity){
                            activityQueue = doc.data().activity;
                        } else {
                            activityQueue = [];
                        }
                        
                        //If it is full (Max 5 items) --> FIFO Queue
                        if (activityQueue.length >= 5) {
                            //Fix the list if it is too great, by recursively shifting until we hit 4
                            for (var i = 0; i < activityQueue.length - 4; i++){
                                activityQueue.shift();
                            }
                        }
                        //Push the new activity
                        activityQueue.push({action: that.action, what: that.what, date: that.date});    
                        
                        //Now update the userRef with out new activityQueue
                        userRef.doc(doc.id).update({activity: activityQueue}).then(function(){
                            //Give the user feedback on what they posted
                            console.log("Activity Posted"); //eslint-disable-line
                        })
                        .catch(function(error){
                            //Alert them of the failed comment post
                            console.log("Error: " + error); //eslint-disable-line
                        })
                    })
                });                   
            }
        }
    }
}